var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOnBoarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 54,
    viewBox: "0 0 64 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9302 42.75H31.4302V38.25C31.4302 36.45 30.7102 34.74 29.4502 33.48C28.1902 32.22 26.4802 31.5 24.6802 31.5H15.6802C13.8802 31.5 12.1702 32.22 10.9102 33.48C9.65018 34.74 8.93018 36.45 8.93018 38.25V42.75H4.43018V38.25C4.43018 35.28 5.63018 32.4 7.73018 30.3C9.83018 28.2 12.7102 27 15.6802 27H24.6802C27.6502 27 30.5302 28.2 32.6302 30.3C34.7302 32.4 35.9302 35.28 35.9302 38.25V42.75Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.18 4.5C21.53 4.5 22.82 4.89 23.93 5.64C25.04 6.39 25.91 7.44 26.42 8.67C26.93 9.9 27.05 11.25 26.81 12.57C26.54 13.89 25.91 15.09 24.95 16.02C24.02 16.95 22.79 17.61 21.5 17.88C20.18 18.15 18.83 18 17.6 17.49C16.37 16.98 15.32 16.11 14.57 15C13.82 13.89 13.43 12.57 13.43 11.25C13.43 9.45 14.15 7.74 15.41 6.48C16.67 5.22 18.38 4.5 20.18 4.5ZM20.18 0C17.96 0 15.77 0.66 13.94 1.89C12.08 3.12 10.64 4.89 9.79999 6.93C8.95999 9 8.71999 11.25 9.16999 13.44C9.58999 15.63 10.67 17.64 12.26 19.2C13.82 20.76 15.83 21.84 18.02 22.29C20.21 22.71 22.46 22.5 24.53 21.66C26.6 20.82 28.34 19.38 29.57 17.52C30.8 15.66 31.46 13.5 31.46 11.28C31.46 8.31 30.26 5.43 28.16 3.33C26.06 1.23 23.18 0.03 20.21 0.03L20.18 0Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 49.5H0.5V54H63.5V49.5Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 11.28H54.5V2.28003H50V11.28H41V15.78H50V24.78H54.5V15.78H63.5V11.28Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnBoarding);
export default __webpack_public_path__ + "static/media/ic-on-boarding.bfd6ab5470a0bda67bc48b3fe9daaa2f.svg";
export { ForwardRef as ReactComponent };